import logo from '../../layout/leftnav/ppm-logo.png';
import unauthorizedSvg from '../../images/unauthorized.svg';

//css is defined and loaded in /layout/boundary/ErrorBoundary.css
const UnauthorizedUser = props => {
    return (
        <div className="d-flex" id="wrapper">
            <div className="border-end" id="sidebar-wrapper">
                <div>
                    <div className="sidebar-heading"><img src={logo} alt="Payment Portal Logo" /></div>
                    <nav className="nav">{/* empty nav container needed for rendering below 990px widths */}</nav>
                </div>
            </div>
            <div id="page-content-wrapper">
                <div id="error-content" data-testid="error-content">
                    <div className="unauthPanel">
                        <img src={unauthorizedSvg} alt="error" />
                        <p>You are unauthorized to access this site. Please reach out to your Commerce Support Team.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedUser;